import { EVENT_SCHEDULE_ALL_AVAILABLE_TABS, EVENT_SCHEDULE_PREF_TAB_STORAGE_KEY, EVENT_SCHEDULE_PREF_TABS, EVENT_SCHEDULE_TAB_PROGRAM } from '../schedule-header-tabs';

/**
 * Retrieves the default schedule tab preference for the given event ID, or
 * returns {@link EVENT_SCHEDULE_TAB_PROGRAM} if none is found.
 * @param {string} eventId - The ID of the event for which the default schedule
 *     tab preference is requested.
 * @returns {string} The default schedule tab preference, or {@link EVENT_SCHEDULE_TAB_PROGRAM}
 *     if none is found.
 */
export function useDefaultScheduleTab(eventId) {
    const tab = localStorage.getItem(getScheduleTabPrefKey(eventId));
    if (tab && EVENT_SCHEDULE_ALL_AVAILABLE_TABS.includes(tab)) {
        return tab;
    }

    return EVENT_SCHEDULE_TAB_PROGRAM;
}

/**
 * Saves the preferred schedule tab for a given event in local storage.
 *
 * @param {string} eventId - The ID of the event for which the schedule tab preference is being set.
 * @param {string} tab - The tab identifier to be saved as the preferred schedule tab.
 *
 * The function checks if the provided tab is within the predefined list of preference tabs.
 * If so, it stores the tab in local storage with a key generated by concatenating the
 * event schedule preference tab storage key and the eventId.
 */
export function saveDefaultScheduleTab(eventId, tab) {
    if (EVENT_SCHEDULE_PREF_TABS.includes(tab)) {
        localStorage.setItem(getScheduleTabPrefKey(eventId), tab);
    }
}

/**
 * Generates a key for storing the preferred schedule tab in local storage.
 *
 * The generated key is a concatenation of the event schedule preference tab
 * storage key and the eventId.
 *
 * @param {string} eventId - The ID of the event for which the schedule tab preference is being stored.
 * @returns {string} The generated key.
 */
function getScheduleTabPrefKey(eventId) {
    return [EVENT_SCHEDULE_PREF_TAB_STORAGE_KEY, eventId].join();
}


